
























































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { WordSearchPuzzle } from '@/wordsearch/types';
import { formatTimeHMS } from '@/utils/date-helpers';
import { isMobile } from 'mobile-device-detect';
import { musicOnOff, pauseSound, playSound } from '@/utils/playSound';

const puzzle = namespace('Puzzle');

const ui = namespace('UI');

@Component
export default class NavigationBar extends Vue {
  @puzzle.State
  private puzzle!: WordSearchPuzzle;

  @puzzle.State
  private userAnswers!: Record<string, string[]>;

  @puzzle.State
  private puzzleTime!: number;

  @puzzle.State
  private gridSize!: number;

  @ui.Action
  private openRevealPuzzlePopup!: () => void;

  @ui.Action
  private openClearPuzzlePopup!: () => void;

  @ui.Action
  private openCalendarPopup!: () => void;

  @ui.Action
  private openPausePopup!: () => void;

  @ui.Action
  private openHelpPopup!: () => void;

  @ui.Action
  private openHintPopup!: () => void;

  private musicOn: boolean = musicOnOff.musicOn;
  private soundOn: boolean = musicOnOff.soundOn;

  get formattedPuzzleTime() {
    return formatTimeHMS(this.puzzleTime);
  }

  get answersText() {
    return `${Object.keys(this.userAnswers).length}/${this.puzzle.words.length}`;
  }

  // eslint-disable-next-line class-methods-use-this
  private print() {
    window.print();
  }

  get getGridSize() {
    return `
      width: ${isMobile ? this.gridSize : this.gridSize + this.gridSize * 0.3}px;
    `;
  }

  private changeMusic() {
    this.play();
    musicOnOff.musicOn = !musicOnOff.musicOn;
    this.musicOn = musicOnOff.musicOn;
    if (musicOnOff.musicOn) {
      playSound('musicSound');
    } else {
      pauseSound('musicSound');
    }
  }

  private changeSound() {
    this.play();
    musicOnOff.soundOn = !musicOnOff.soundOn;
    this.soundOn = musicOnOff.soundOn;
  }

  private play() {
    playSound('buttonClickSound');
  }

   private on: string = (window as any).languages['On'];
   private off: string = (window as any).languages['Off'];
   private help: string = (window as any).languages['Help'];
   private clear: string = (window as any).languages['Clear'];
}
